<template>
  <div class="room-distribute-dialog">
    <div v-if="distributeType === 'distribute'" class="row-item">
      <r-table
        class="distribute_table"
        ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        @row-click="handleRowClick"
      >
        <el-table-column label="选中" width="80">
          <template #default="scope"><el-radio v-model="checkedId" :label="scope.row.id"></el-radio></template>
        </el-table-column>
        <el-table-column label="用户名"  prop="loginName"></el-table-column>
        <el-table-column label="姓名" prop="name">
          <template #default="scope">{{scope.row.name?scope.row.name:'--'}}</template>
        </el-table-column>
      </r-table>

    </div>
    <div v-else class="row-item">
      <div class="callbackTip">确认回收选中的房源？</div>
    </div>
    <div class="row-item btn-row detail-form">
      <el-button class="primary-btn-g" icon="CircleCheck" @click="submitForm">确 定</el-button>
      <el-button class="warning-btn-g" icon="CircleClose" @click="closeModal">取 消</el-button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapActions, mapGetters ,mapState} from 'vuex'
  import tableMix from '@/components/common/tableListMixin.js'
  import RTable from '@/components/common/RTable'

export default {
  props: {
    distributeType: {
      type: String,
      default: 'distribute'
    },
    distributeModal:{
      type: Boolean,
      default:false,
    },
    operatorButlerList:{
      type:Array,
      default:[]
    },
    roomSel:{
      type:Array,
      default:[]
    }
  },
  mixins: [tableMix],
  components: {
    RTable},
  data() {
    return {
      manager: '',
      managerList: [],
      checkedId:56,
      tableColumn:[],
      tableData:[],
      options: {
        multiSelect: false, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        maxHeight: '300px',
        mutiSelect: false,
        selection: false,
      },
      tableVarity:'table',
      selValue:false
    }
  },
  watch: {
    distributeModal:{
      immediate: true,
      handler: function(to){
        if(to){
          this.checkedId = '-1'
          this.tableData = [...this.operatorButlerList]
        }

      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModel')
    },
    handleRowClick(row, event, column){
      this.tableData.map(item=>{
        if(item.id==row.id){
          this.checkedId = row.id
        }
      })
    },
    submitForm(){
      let params = {}
      let url = ''
      let housekeeperId = this.checkedId
      let ids = []
      this.roomSel.length && this.roomSel.map(item=>{
        ids.push(item.id)
      })

      if(this.distributeType=='recovery'){
        url = 'SAAS.ROOM_CALLBACK'
        params = {ids:ids.join(',')}
      }else{
        url = 'SAAS.ROOM_PLAN'
        params = {ids:ids.join(','),housekeeperId:housekeeperId}
      }

      this.fetchData({url:url, method: 'get', params:{params:JSON.stringify(params)},timeout:0, isLoading:false, flag:true}).then((res)=>{
        if(res.status==1){
          this.$message.success(res.msg||'操作成功！')
          this.$emit('submitSuccess')
        }else{
          this.$message.error(res.msg||'操作失败！')
        }
        this.saveLoading = false
      }).catch((err)=>{
        this.$message.error('操作失败！')
        this.saveLoading = false
      }).finally (()=>{
        this.saveLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.room-distribute-dialog {
  .row-item {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .item-label {
      width: 100px;
      text-align: right;
    }
    .item-content {
      flex: 1;
    }
  }
  .btn-row {
    justify-content: center;
  }
  .detail-form .el-button + .el-button {
    margin-left: 50px !important;
  }
  .distribute_table{
    width: 100%;

  }
  .el-radio /deep/ .el-radio__label{
    display: none;
  }
  .el-radio /deep/ .el-radio__input{
    margin-left: 6px;
  }
  .callbackTip{
    padding-left: 200px;
    margin-bottom: 20px;
    font-weight: 700 !important;
    color: rgba(0, 0, 0, 0.84705882) !important;
  }
}
</style>
